import axios from 'axios';

class RequestUtil {
  constructor(endpoint) {
    this.endpoint = endpoint
  }

  async get(url="", path, headers) {
    try {
      const response = await axios.get(`${this.endpoint? this.endpoint : url}${path}`, {headers});
      return {
        status: "ok",
        ...response.data && {data: response.data}
      }
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        message: error
      }
    }
  }

  async post(url="", path, headers, payload) {
    try {
      const response = await axios.post(`${this.endpoint? this.endpoint : url}${path}`, payload, {headers});
      return {
        status: "ok",
        ...response.data && {data: response.data}
      }
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        message: error
      }
    }
  }
}

export default RequestUtil